import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import {
    TwEnvioMuestraLaboratorioSolicitudExViewModel,
    MotivoMuestraLaboratorioSolicitudExViewModel,
    MotivoMuestraLaboratorioExViewModel,
    SolicitudLaboratorioExViewModel,
} from '../laboratorioEx.types';
import { TProductoSolicitudExViewModel, TwEmbalajesExViewModel } from '../../productos/productosEx.types';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';

@Component({
    selector: 'app-laboratorioex-enviomuestras',
    templateUrl: './laboratorioex-enviomuestras.component.html',
})
export class LaboratorioExEnvioMuestrasComponent extends ComponentBase implements OnInit, OnChanges {
    public isCollapsedCabecera = false;

    motivosMuestraLaboratorioEx: MotivoMuestraLaboratorioSolicitudExViewModel[];
    productosMuestraLaboratorioEx: TProductoSolicitudExViewModel[];
    embalajesMuestraLaboratorioEx: TwEmbalajesExViewModel[];

    @Input() formGroup: FormGroup;
    @Input() solicitudLaboratorioEx: SolicitudLaboratorioExViewModel;
    @Input() esPerfilInspector = false;
    @Input() esPerfilConsultasyLaboratorio = false;
    @Input() listMotivosEx: MotivoMuestraLaboratorioExViewModel[];
    @Input() listProductosEx: TProductoSolicitudExViewModel[];
    @Input() listEmbalajesEx: TwEmbalajesExViewModel[];
    @Input() listMotivosSolicitudEx: MotivoMuestraLaboratorioSolicitudExViewModel[];
    @Input() hayEnvioMuestrasInspectorEx = false;
    @Input() envioMuestrasEx: TwEnvioMuestraLaboratorioSolicitudExViewModel;
    @Input() enviandoMuestrasEx = false;

    @Output() addMotivosMuestraLaboratorioEx = new EventEmitter<MotivoMuestraLaboratorioSolicitudExViewModel[]>();
    @Output() addProductosMuestraLaboratorioEx = new EventEmitter<TProductoSolicitudExViewModel[]>();
    @Output() addEmbalajesMuestraLaboratorioEx = new EventEmitter<TwEmbalajesExViewModel[]>();

    constructor(protected authService: AuthService, protected notificacionService: NotificationService, protected exceptionHandler: ExceptionManager) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.form = this.formGroup;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes?.listMotivosSolicitudEx?.currentValue) {
            this.motivosMuestraLaboratorioEx = this.listMotivosSolicitudEx;
        }
        if (changes?.envioMuestrasEx?.currentValue) {
            if (this.hayEnvioMuestrasInspectorEx) {
                this.formGroup.controls['IdMotivoEx'].disable();
                this.formGroup.controls['IdProductoEx'].disable();
                this.formGroup.controls['IdEmbalajeEx'].disable();
                this.productosMuestraLaboratorioEx = this.solicitudLaboratorioEx.TProductoSolicitudExCollection.filter(p => p.MuestraLaboratorio === true);
                this.embalajesMuestraLaboratorioEx = this.solicitudLaboratorioEx.TwEmbalajesExCollection.filter(e => e.MuestraLaboratorio === true);
                this.updateForm();
            }
        }
    }

    private updateForm(): void {
        this.formGroup.patchValue({
            IdMotivoEx: null,
            IdProductoEx: null,
            IdEmbalajeEx: null,
        });
    }

    onAddMotivoEx(): void {
        if (this.form.value.IdMotivoEx != null && this.form.value.IdMotivoEx > 0) {
            this.removeValidators('IdMotivoEx');
            let currentMotivoEx = new MotivoMuestraLaboratorioSolicitudExViewModel();
            currentMotivoEx.IdMotivoEx = this.form.value.IdMotivoEx;
            currentMotivoEx.IdSolicitudEx = this.solicitudLaboratorioEx.Id;

            if (this.motivosMuestraLaboratorioEx == null) {
                this.motivosMuestraLaboratorioEx = new Array<MotivoMuestraLaboratorioSolicitudExViewModel>();
            }
            //Comprobamos que no esté ya incluido
            let yaIncluido = this.motivosMuestraLaboratorioEx.find(m => m.IdMotivoEx == currentMotivoEx.IdMotivoEx);

            if (!yaIncluido) {
                //Si no está incluido todavía, actualizamos el listbox
                const motEx = this.listMotivosEx.find(m => m.Id == currentMotivoEx.IdMotivoEx);
                currentMotivoEx.DescripcionMotivo = motEx!.Descripcion;

                this.motivosMuestraLaboratorioEx.push(currentMotivoEx);

                this.removeValidators('IdMotivoEx');
                this.form.patchValue({
                    IdMotivoEx: null,
                });
                this.addMotivosMuestraLaboratorioEx.emit(this.motivosMuestraLaboratorioEx);
            }
        }
    }

    onDeleteMotivoEx(item: MotivoMuestraLaboratorioSolicitudExViewModel): void {
        this.motivosMuestraLaboratorioEx.splice(this.motivosMuestraLaboratorioEx.indexOf(item), 1);
        if (this.motivosMuestraLaboratorioEx.length == 0) {
            this.addValidator('IdMotivoEx', Validators.required);
        }
    }

    onAddProductoEx(): void {
        if (this.form.value.IdProductoEx != null && this.form.value.IdProductoEx > 0) {
            this.removeValidators('IdProductoEx');
            let currentProductoEx = new TProductoSolicitudExViewModel();
            currentProductoEx.Id = this.form.value.IdProductoEx;

            if (this.productosMuestraLaboratorioEx == null) {
                this.productosMuestraLaboratorioEx = new Array<TProductoSolicitudExViewModel>();
            }
            //Comprobamos que no esté ya incluido
            let yaIncluido = this.productosMuestraLaboratorioEx.find(m => m.Id == currentProductoEx.Id);

            if (!yaIncluido) {
                const prodEx = this.listProductosEx.find(item => item.Id === this.form.value.IdProductoEx);
                if (!prodEx) {
                    return;
                }
                //Si no está incluido todavía, actualizamos el listbox
                currentProductoEx.MuestraLaboratorio = true;
                currentProductoEx.IdTaricProductoNombreCientificoNombreComun = prodEx.IdTaricProductoNombreCientificoNombreComun!;

                this.productosMuestraLaboratorioEx.push(currentProductoEx);

                this.removeValidators('IdProductoEx');
                this.form.patchValue({
                    IdProductoEx: null,
                });
                this.addProductosMuestraLaboratorioEx.emit(this.productosMuestraLaboratorioEx);
            }
        }
    }

    onDeleteProductoEx(item: TProductoSolicitudExViewModel): void {
        this.productosMuestraLaboratorioEx.splice(this.productosMuestraLaboratorioEx.indexOf(item), 1);

        if (this.productosMuestraLaboratorioEx.length == 0) {
            this.addValidator('IdProductoEx', Validators.required);
        }
    }

    onAddEmbalajeEx(): void {
        if (this.form.value.IdEmbalajeEx != null && this.form.value.IdEmbalajeEx > 0) {
            this.removeValidators('IdEmbalajeEx');
            let currentEmbalajeEx = new TwEmbalajesExViewModel();
            currentEmbalajeEx.Id = this.form.value.IdEmbalajeEx;

            if (this.embalajesMuestraLaboratorioEx == null) {
                this.embalajesMuestraLaboratorioEx = new Array<TwEmbalajesExViewModel>();
            }
            //Comprobamos que no esté ya incluido
            let yaIncluido = this.embalajesMuestraLaboratorioEx.find(m => m.Id == currentEmbalajeEx.Id);

            if (!yaIncluido) {
                const embEx = this.listEmbalajesEx.find(item => item.Id === this.form.value.IdEmbalajeEx);
                if (!embEx) {
                    return;
                }
                //Si no está incluido todavía, actualizamos el listbox
                currentEmbalajeEx.MuestraLaboratorio = true;
                currentEmbalajeEx.IdTaricEmbalajeDescripcion = embEx.IdTaricEmbalajeDescripcion;

                this.embalajesMuestraLaboratorioEx.push(currentEmbalajeEx);

                this.removeValidators('IdEmbalajeEx');
                this.form.patchValue({
                    IdEmbalajeEx: null,
                });
                this.addEmbalajesMuestraLaboratorioEx.emit(this.embalajesMuestraLaboratorioEx);
            }
        }
    }

    onDeleteEmbalajeEx(item: TwEmbalajesExViewModel): void {
        this.embalajesMuestraLaboratorioEx.splice(this.embalajesMuestraLaboratorioEx.indexOf(item), 1);

        if (this.embalajesMuestraLaboratorioEx.length == 0) {
            this.addValidator('IdEmbalajeEx', Validators.required);
        }
    }
}
